<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.datos_anuales.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>

              
              <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn  color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSV">
                  {{$t('comun.boton_importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleCSVUpload"
                  />
                </v-btn>
              </v-col>
              


            <!-- <v-col cols="12">
                <v-container>
                  <v-row>      
                    <v-col cols=12>
                      <div id="app2">
                          <v-grid 
                          theme="material" 
                          :source="datos" 
                          :columns="columns"
                          canFocus=true
                            range=true
                            useClipboard=true
                            readonly=false
                            filter=true
                            resize=true    
                            @afteredit="handleCellEdit"                        
                          ></v-grid>      
                      </div>
                    </v-col>      
                  </v-row>
                </v-container>

            </v-col> -->
            </v-row>
        </v-card-text>
   

  
   <!-- Bloque de tablas en dos columnas -->
<v-row class="mt-2" align="start" no-gutters>
  <!-- Col izquierda: Valores límite -->
  <v-col cols="12" md="6" class="pr-md-2">
    <v-card-title>
      {{ $t('simulacion.modulo.datos_anuales.tabla.tabla_limite.titulo') }}
    </v-card-title>
<!-- TABLA 1: Valores límite -->
    <div class="tabla-container">
      <table class="tabla-estilizada">
        <thead>
          <tr>
            <th v-for="col in columnsLimite" :key="col.prop" :style="{ width: col.w }">
              <div class="th-wrap">{{ col.name }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fila, index) in visibleDatos" :key="'lim-' + index">
            <td>{{ anioOf(fila) }}</td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.emi)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.emi=Number(v); validarCampo(fila,'emi'); }"
                     class="campo"/>
            </td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.limres)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.limres=Number(v); validarCampo(fila,'limres'); }"
                     class="campo"/>
            </td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.preciol)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.preciol=Number(v); validarCampo(fila,'preciol'); }"
                     class="campo"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-col>

  <!-- Col derecha: Valores previstos -->
  <v-col cols="12" md="6" class="pl-md-2">
    <v-card-title>
      {{ $t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.titulo') }}
    </v-card-title>

    <div class="tabla-container">
      <table class="tabla-estilizada">
        <thead>
          <tr>
            <th v-for="col in columnsPrevistos" :key="col.prop" :style="{ width: col.w }">
              <div class="th-wrap">{{ col.name }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fila, index) in visibleDatos" :key="'prev-' + index">
            <td>{{ anioOf(fila) }}</td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.ghg)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.ghg=Number(v); validarCampo(fila,'ghg'); }"
                     class="campo"/>
            </td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.res)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.res=Number(v); validarCampo(fila,'res'); }"
                     class="campo"/>
            </td>
            <td>
              <select :disabled="disabled" v-model="fila.corr" class="select-binario">
                <option :value="1">{{ $t('simulacion.modulo.datos_anuales.tabla.opcion_mensual_true') }}</option>
                <option :value="0">{{ $t('simulacion.modulo.datos_anuales.tabla.opcion_mensual_false') }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-col>
</v-row>
</v-card>

</template>

<script>
//import VGrid from "@revolist/vue3-datagrid";
//import axios from 'axios';
//import store from '../store';
//import ComponenteLoading from './ComponenteLoading.vue';
export default {

  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    datos_generales:{
        type:Object,
        required:true,
    },
    disabled:{
      type:Boolean,
      default:false,
    }
  },

  data() {
    return {
      anio_min:2025,
      anio_max:2100,
      loading: false,
      first_index:0,
      last_index:50,
        columnsLimite: [
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.anio'),                 prop: 'anio',   w:'9%',  readonly: true },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_emisiones_h2'),     prop: 'emi',    w:'30%' },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_res'),              prop: 'limres', w:'16%' },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.precio_limite'),        prop: 'preciol', w:'45%'},
    ],
    columnsPrevistos: [
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.anio'),              prop: 'anio',   w:'9%',  readonly: true },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.ghg'),               prop: 'ghg',    w:'30%' },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.res'),               prop: 'res',    w:'30%' },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.correlacion'),       prop: 'corr',   w:'30%' },
    ],

    //  Exportación combinada (las dos tablas en un CSV)
    exportColumns: [
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.anio'),             prop: 'anio'    },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_emisiones_h2'), prop: 'emi'     },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_res'),          prop: 'limres'  },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.precio_limite'),    prop: 'preciol' },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.ghg'),           prop: 'ghg'     },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.res'),           prop: 'res'     },
      { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.correlacion'),   prop: 'corr'    },
    ],

    //  Cabeceras aceptadas al importar (nuevas/antiguas y ES/EN)
    columnasEsperadas: {
      anio: [
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.anio'),
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.anio'),
        this.$t('simulacion.modulo.datos_anuales.tabla.anio'),
        'Año','Anio','Year'
      ],
      emi: [
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_emisiones_h2'),
        this.$t('simulacion.modulo.datos_anuales.tabla.emisiones'),
        'Límite Emisiones H2 (gCO2/MJ)','Limite Emisiones H2 (gCO2/MJ)',
        'Emisiones H2 (gCO2/MJ)','H2 Emissions (gCO2/MJ)','H2 Emissions Limit (gCO2/MJ)'
      ],
      limres: [
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_res'),
        'Límite RES (%)','Limite RES (%)','RES Limit (%)'
      ],
      preciol: [
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.precio_limite'),
        this.$t('simulacion.modulo.datos_anuales.tabla.precio_limite'),
        'Precio límite compra a mercado (EUR/MWh)',
        'Precio limite compra a mercado (EUR/MWh)',
        'Market purchase price limit (EUR/MWh)'
      ],
      ghg: [
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.ghg'),
        this.$t('simulacion.modulo.datos_anuales.tabla.GHG'),
        'GHG (gCO2/MJ)','GHG'
      ],
      res: [
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.res'),
        this.$t('simulacion.modulo.datos_anuales.tabla.RES'),
        'RES (%)','RES'
      ],
      corr: [
        this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.correlacion'),
        this.$t('simulacion.modulo.datos_anuales.tabla.correlacion'),
        'Correlación','Correlacion','Correlation'
      ],

    },
      


    };
  },

  components: {
    //VGrid,
    //ComponenteLoading,
  },
  computed: {
  datos: {
    get() {
      return this.modelValue;
    },
    set(val) {
      this.$emit('update:modelValue', val);
    }
  },
  visibleDatos() {
   const y0 = Number(this.datos_generales?.anio_inicio);
    const y1 = Number(this.datos_generales?.anio_fin);
    if (!Number.isFinite(y0) || !Number.isFinite(y1)) return [];
    const arr = Array.isArray(this.datos) ? this.datos : [];
    // NO clonar: devolvemos las MISMAS referencias
    return arr.filter(r => {
      const y = this.anioOf(r);
      return Number.isFinite(y) && y >= y0 && y <= y1;
    });
}
},


  watch: {
    'datos_generales.anio_inicio'(val) {
    console.log('[DatosAnuales] anio_inicio cambió a', val);
  },
  'datos_generales.anio_fin'(val) {
    console.log('[DatosAnuales] anio_fin cambió a', val);
  },
   
    '$i18n.locale'() {     
      
        this.columnsLimite = [
      { name: this.$t('rfnbo.tabla_limite.anio'),             prop: 'anio',   w:'8%',  readonly: true },
      { name: this.$t('rfnbo.tabla_limite.lim_emisiones_h2'), prop: 'emi',    w: '28%' },
      { name: this.$t('rfnbo.tabla_limite.lim_res'),          prop: 'limres', w: '15%' },
      { name: this.$t('rfnbo.tabla_limite.precio_limite'),    prop: 'preciol',w: '49%' },
    ];
    this.columnsPrevistos = [
      { name: this.$t('rfnbo.tabla_previstos.anio'),        prop: 'anio',   w: '18%',  readonly: true },
      { name: this.$t('rfnbo.tabla_previstos.ghg'),         prop: 'ghg',    w: '26%' },
      { name: this.$t('rfnbo.tabla_previstos.res'),         prop: 'res',    w: '26%' },
      { name: this.$t('rfnbo.tabla_previstos.correlacion'), prop: 'corr',   w: '30%' },
    ];
this.exportColumns = [
    { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.anio'),             prop: 'anio'    },
    { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_emisiones_h2'), prop: 'emi'     },
    { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.lim_res'),          prop: 'limres'  },
    { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_limite.precio_limite'),    prop: 'preciol' },
    { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.ghg'),           prop: 'ghg'     },
    { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.res'),           prop: 'res'     },
    { name: this.$t('simulacion.modulo.datos_anuales.tabla.tabla_previstos.correlacion'),   prop: 'corr'    },
  ];
    },
    


  },

methods: {
  
  anioOf (r) {
    return Number(r?.anio ?? r?.year ?? r?.Year ?? r?.ANIO ?? r?.Anio);
  },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value !== 'number') value = Number(value);

      if (Number.isInteger(value)) {
        return value.toString().replace('.', ',');
      } else {
        return value.toString().replace('.', ',');
      }
    },

    handleCellEdit(event) {
      
      console.log("Intercepta...");

      // Acceder al detalle del evento
      const { detail } = event;

      // Convertir a número si la columna es "valor"
      if (detail.prop === "valor") {
        const newValue = Number(detail.val);

        // Actualizar el modelo de la fila correspondiente
        const rowIndex = detail.rowIndex;
        this.datos[rowIndex][detail.prop] = newValue;

        // Confirmación en consola
        console.log(`Fila actualizada (${rowIndex}):`, this.datos[rowIndex]);
      }
    },


     exportToCSV() {
  const delim = ';';
  const headers = this.exportColumns.map(c => c.name).join(delim);

  const rows = this.visibleDatos.map(row => {
    return this.exportColumns.map(c => {
      const prop = c.prop;
      let v = (prop === 'anio') ? this.anioOf(row) : row?.[prop];

      // normaliza correlación a 0/1
      if (prop === 'corr') v = Number(v ?? 0);

      if (v === null || v === undefined || v === '') return '';
      if (typeof v === 'number') return String(v).replace('.', ','); // coma decimal
      const s = String(v);
      return /^\d+\.\d+$/.test(s) ? s.replace('.', ',') : s;
    }).join(delim);
  }).join('\n');

  const csv = headers + '\n' + rows;
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'rfnbo_valores.csv';
  a.click();
  URL.revokeObjectURL(url);
},

// === IMPORTAR DESDE LA TABLA COMBINADA ===
importFromCSV() {
  this.$refs.fileInput.click();
},
   guess_delimiter(firstLine) {
  const c = (firstLine.match(/,/g) || []).length;
  const s = (firstLine.match(/;/g) || []).length;
  return c > s ? ',' : ';';
},
splitCSV(line, delim) {
  const out = [];
  let cur = '', inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (inQuotes && line[i+1] === '"') { cur += '"'; i++; }
      else inQuotes = !inQuotes;
    } else if (ch === delim && !inQuotes) {
      out.push(cur); cur = '';
    } else {
      cur += ch;
    }
  }
  out.push(cur);
  return out.map(s => s.trim());
},
parseNumber(raw) {
  if (raw === null || raw === undefined) return null;
  let s = String(raw).trim();
  if (s === '') return null;
  const hasPct = s.endsWith('%'); if (hasPct) s = s.slice(0, -1);
  // quitar miles con punto y deja coma como decimal
  s = s.replace(/\s/g, '').replace(/(?<=\d)[.](?=\d{3}\b)/g, '');
  s = s.replace(',', '.');
  const n = Number(s);
  return Number.isNaN(n) ? null : n;
},
parseCorr(v) {
  if (v === null || v === undefined) return 0;
  const s = String(v).trim().toLowerCase();
  if (['1','true','sí','si','yes','y'].includes(s)) return 1;
  if (['0','false','no','n'].includes(s)) return 0;
  const n = Number(s);
  return Number.isNaN(n) ? 0 : (n ? 1 : 0);
},

    verificarClaveEnColumnas(dict){
      let todos=true;
      // Recorrer el diccionario
      Object.keys(dict).forEach(key => {
        // Buscar si el valor de la clave del dict está dentro de los arrays de columnasEsperadas
        const coincidencia = Object.keys(this.columnasEsperadas).some(columna => {
          return this.columnasEsperadas[columna].some(valor => valor.includes(dict[key].toLowerCase().trim()));
        });

        if (coincidencia) {
          console.log(`La clave "${key}" se encuentra en las columnas esperadas`);
          
        } else {
          console.log(`La clave "${key}" NO se encuentra en las columnas esperadas`);
        }
        todos=todos & coincidencia
      });
      return todos
    },
    devolverPropColumnas(rotulo) {
  const norm = s => s?.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                         .toLowerCase().trim();
  const key = Object.keys(this.columnasEsperadas).find(prop =>
    this.columnasEsperadas[prop].some(lbl => norm(lbl) === norm(rotulo))
  );
  return key || null;
},
revisarCabeceras(header) {
  const props = header.map(h => this.devolverPropColumnas(h)).filter(Boolean);
  if (!props.includes('anio')) {
    alert(this.$t('mensajes.alerta_cabeceras') + ' (falta Año/Year)');
    return true;
  }
  return false;
},

  handleCSVUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const csvData = e.target.result;
    // dividir por líneas y elimina vacías
    const lines = csvData.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
    if (!lines.length) return;

    const delim = this.guess_delimiter(lines[0]);
    const header = this.splitCSV(lines[0], delim);
    if (this.revisarCabeceras(header)) return;

    const idx2prop = header.map(h => this.devolverPropColumnas(h));

    // parse filas
    const parsed = lines.slice(1).map(line => {
      const values = this.splitCSV(line, delim);
      const obj = {};
      idx2prop.forEach((prop, i) => {
        if (!prop) return;
        const raw = (values[i] ?? '').toString().trim();
        if (prop === 'corr') {
          obj[prop] = this.parseCorr(raw);
        } else if (prop === 'anio') {
          obj[prop] = Number(this.parseNumber(raw));
        } else {
          const n = this.parseNumber(raw);
          obj[prop] = (n === null ? null : n);
        }
      });
      return obj;
    });

    // dejar filas con año válido
    const conAnio = parsed.filter(x => Number.isFinite(x.anio));
    const mapByYear = new Map(conAnio.map(x => [Number(x.anio), x]));

    
    const merged = (Array.isArray(this.datos) ? this.datos : []).map(item => {
      const y = this.anioOf(item);
      if (Number.isFinite(y) && y >= this.anio_min && y <= this.anio_max && mapByYear.has(y)) {
        const upd = mapByYear.get(y);
        // No machacar con null/undefined: solo aplicar valores presentes
        const next = { ...item };
        ['emi','limres','preciol','ghg','res','corr'].forEach(k => {
          if (Object.prototype.hasOwnProperty.call(upd, k) && upd[k] !== null && upd[k] !== '') {
            next[k] = (k === 'corr') ? Number(upd[k]) : upd[k];
          }
        });
        
        if (upd.anio) next.anio = Number(upd.anio);
        return next;
      }
      return item;
    });

    this.datos = [...merged]; // dispara v-model
  };
  reader.readAsText(file, 'UTF-8');
  event.target.value = '';
},
    validarCampo(fila, campo) {
      if (fila[campo] < 0) {
        fila[campo] = 0;
        alert(this.$t('El valor no puede ser negativo'));
      }
    },


normalizeRow(r) {
    const out = { ...r };
    const numericDefaults = { emi:0, limres:0, preciol:0, ghg:0, res:0, corr:0 };
    Object.entries(numericDefaults).forEach(([k, def]) => {
      const v = out[k];
      // si no existe o es NaN -> 0; si existe -> número
      out[k] = (v === undefined || v === null || v === '' || Number.isNaN(Number(v)))
        ? def
        : Number(v);
    });
    return out;
  },
  normalizeAll() {
    const arr = Array.isArray(this.datos) ? this.datos : [];
    this.datos = arr.map(r => this.normalizeRow(r));
  },


  },
  async mounted(){
    
    console.log("Datos: ", this.datos)
    this.first_index=this.datos_generales.anio_inicio-this.anio_min
    this.last_index=this.datos_generales.anio_fin-this.anio_min+1
     this.normalizeAll();
    
  }
};


</script>

<style scoped>
#app2 {
  height: 400px;
  width: 100%;
}
revo-grid {
  height: 100%;
  width: 100%;
  font-size: 12px;
}

.tabla-container {
  max-width: 100%;
  overflow-x: auto;
  margin-top: 20px;
}

.tabla-estilizada {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.tabla-estilizada th,
.tabla-estilizada td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.tabla-estilizada th {
  background-color: #0078D4;
  font-weight: bold;
  color: white;
}

.tabla-estilizada tr:nth-child(even) {
  background-color: #eef6ff;
}

.tabla-estilizada tr:hover {
  background-color: #8bb6e7;
}




/*
#eef6ff
#bfddf5

*/
.campo,
.select-binario {
  width: 90%;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
}



/* Evita scroll horizontal y permite que el contenido se parta */
.tabla-container { overflow-x: hidden; }

/* Hace que la tabla use todo el ancho disponible sin desbordar */
.tabla-estilizada {
  table-layout: fixed; /* muy importante para que el wrap funcione por columna */
  width: 100%;
  border-collapse: collapse;
}

/* Permite que celdas se encojan */
.tabla-estilizada th,
.tabla-estilizada td {
  min-width: 0;
}

/* Cabeceras con salto de línea */
.tabla-estilizada th { 
  white-space: normal;
  vertical-align: top;
 
}

/* Envolver cualquier palabra larga en la cabecera */
.th-wrap {
  display: block;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
  line-height: 1.2;
}

/* Inputs/select no fuerzan ancho extra */
.tabla-estilizada input,
.tabla-estilizada select {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}


</style>

